export type ThemeColorConditions = {
  base: string;
  _themeBlack: string;
  _themeWhite: string;
};

export function themeColor(value: ThemeColorConditions) {
  return { value };
}
